import { useMemo } from 'react'
import { Badge, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { Business as ManufacturerIcon } from '@mui/icons-material'
import { useGetManufacturerLogo } from 'interface/manufacturer'
import { SearchListWithManufacturer } from 'features/search/types'

type ManufacturerLinkItemProps = {
  isSmallMedia: boolean
} & SearchListWithManufacturer

export const ManufacturerLinkItem = ({
  manufacturerId,
  manufacturerName,
  updateTime,
  searchList,
  isSmallMedia
}: ManufacturerLinkItemProps) => {
  const manufacturerLogoState = useGetManufacturerLogo(manufacturerId, updateTime)
  const logo = useMemo(
    () => manufacturerLogoState.data ? URL.createObjectURL(manufacturerLogoState.data.blob) : undefined,
    [manufacturerLogoState]
  )
  return (
    <ListItemButton href={`#manufacturer-${manufacturerId}`} dense sx={{ paddingLeft: 2, paddingRight: 4, paddingY: 1 }}>
      <ListItemIcon sx={{ justifyContent: 'center', marginRight: 1 }}>
        {logo ? (
          <img
            src={logo}
            alt={manufacturerName ?? '製薬企業'}
            style={{
              width: '56px',
              maxHeight: '1.5rem',
              objectFit: 'contain',
              verticalAlign: 'middle'
            }}
          />
        ) : (
          <ManufacturerIcon fontSize="medium" color="disabled"/>
        )}
      </ListItemIcon>
      <ListItemText sx={{ paddingRight: 3, maxWidth: isSmallMedia ? 'undefined' : '8rem' }}>
        {manufacturerName}
      </ListItemText>
      <Badge badgeContent={`${searchList.length} 件`} color="default" sx={{ whiteSpace: 'nowrap' }}/>
    </ListItemButton>
  )
}
